import { render, staticRenderFns } from "./SpyNavigationForTablet.vue?vue&type=template&id=00c89ec8&"
import script from "./SpyNavigationForTablet.vue?vue&type=script&lang=js&"
export * from "./SpyNavigationForTablet.vue?vue&type=script&lang=js&"
import style0 from "./SpyNavigationForTablet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports